export default [
  {
    path: '/Main/Balai/Kontrak',
    component: () => import('../pages/Kontrak/Kontrak.vue'),
  },
  {
    path: '/Main/Balai/Retribusi',
    component: () => import('../pages/Retribusi/Retribusi.vue'),
  },
  {
    path: '/Main/Data/Kegiatan',
    component: () => import('../pages/Data/Kegiatan.vue'),
  },
  {
    path: '/Main/Data/Balai',
    component: () => import('../pages/Data/Balai.vue'),
  },
  {
    path: '/Main/Data/PhoFho',
    component: () => import('../pages/PhoFho/PhoFho.vue'),
  },
  {
    path: '/Main/Report/Report',
    component: () => import('../pages/Kontrak/Report.vue'),
  },
]
